import React from 'react';

import Main from '../components/Main';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div>
      <Main />
      <Footer />
    </div>
  );
};

export default LandingPage;
